<script setup>
import { logEvent } from '@/utils/firebase.js';

const handleFacebookClick = () => {
  logEvent('pc_fengsui_facebook_click');
};

const handleYoutubeClick = () => {
  logEvent('pc_fengsui_youtube_click');
};

const handleInstagramClick = () => {
  logEvent('pc_fengsui_ins_click');
};
</script>

<template>
  <footer class="footer-section">
    <div class="social-icons">
      <a
        href="https://www.facebook.com/fswht123"
        target="_blank"
        rel="noopener noreferrer"
        class="social-icon facebook"
        @click="handleFacebookClick"
      >
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          width="10"
          height="10"
        >
          <path
            d="M15.12 5.32H17V2.14A26.11 26.11 0 0 0 14.26 2c-2.72 0-4.58 1.66-4.58 4.7v2.62H6.61v3.56h3.07V22h3.68v-9.12h3.06l.46-3.56h-3.52V7.05c0-1.05.28-1.73 1.76-1.73z"
          />
        </svg>
      </a>
      <a
        href="https://www.youtube.com/@fengsuidsx"
        target="_blank"
        rel="noopener noreferrer"
        class="social-icon youtube"
        @click="handleYoutubeClick"
      >
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          width="10"
          height="10"
        >
          <path
            d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
          />
        </svg>
      </a>
      <a
        href="https://www.instagram.com/fengsuidashixiong/"
        target="_blank"
        rel="noopener noreferrer"
        class="social-icon instagram"
        @click="handleInstagramClick"
      >
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          width="10"
          height="10"
        >
          <path
            d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
          />
        </svg>
      </a>
    </div>
    <div class="footer-address">
      <p>
        長沙灣長順街20號（時豐中心13樓1305室）（戊日不開放，其他日期早10點-晚7點開放） Kowloon, Hong
        Kong
      </p>
    </div>
  </footer>
</template>

<style scoped lang="scss">
.footer-section {
  padding: 40px;
  background: rgb(28, 28, 28);
  text-align: center;
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
}

.social-icon {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: rgba(229, 174, 64, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(229, 174, 64, 0.7);
    transform: scale(1.1);
  }

  svg {
    width: 10px;
    height: 10px;
  }
}

.footer-address {
  margin-top: 10px;
}

.footer-address p {
  font-size: 8px;
  color: #65686c;
  line-height: 1.8;
  margin: 0;
}
</style>
